// PopupNotificationList.js
import { connect } from 'react-redux';
import PopupNotificationList from '../component/PopupNotificationList.jsx';

import getListData from '../selector/getListData.js';
import { LIST_SELECT_PATH_PREFIX } from '../resource/popupNotificationConstants.js';

const mapStateToProps = state => {
  return {
    notificationTags: getListData(state, LIST_SELECT_PATH_PREFIX, 'itemIds'),
  };
};

export default connect(mapStateToProps, null)(PopupNotificationList);
